(() => {
  const backdrop = document.getElementById("smu-upsell-backdrop");
  const modal = document.getElementById("smu-upsell-modal");
  const img = document.getElementById("smu-upsell-img");
  if (!backdrop || !modal) return;

  // Magnet IDs aus der Collection
  const MAGNET_PRODUCT_IDS = Array.isArray(window.SMU_UPSELL?.magnetProductIds)
    ? window.SMU_UPSELL.magnetProductIds.map(Number)
    : [];

  // Fallback: wenn aus irgendeinem Grund leer, soll es nicht ständig nerven
  // (dann zeigt es einfach nie an)
  if (!MAGNET_PRODUCT_IDS.length) return;

  const STORAGE_KEY = "smu_second_magnet_upsell_cooldown_v1";
  const COOLDOWN_MINUTES = 60;

  function now() {
    return Date.now();
  }

  function dismissedUntil() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return 0;
      const v = JSON.parse(raw);
      return Number(v.until || 0);
    } catch {
      return 0;
    }
  }

  function setCooldown() {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ until: now() + COOLDOWN_MINUTES * 60 * 1000 })
      );
    } catch {}
  }

  function applyInlineOverlayPriority() {
    // Immer über UpCart & allem anderen
    backdrop.style.zIndex = "2147483646";
    modal.style.zIndex = "2147483647";
  }

  function openModal() {
    if (dismissedUntil() > now()) return;

    applyInlineOverlayPriority();

    if (img && window.SMU_UPSELL?.magnetImageUrl) {
      img.src = window.SMU_UPSELL.magnetImageUrl;
    }

    backdrop.hidden = false;
    modal.hidden = false;
    document.documentElement.style.overflow = "hidden";
  }

  function closeModal() {
    backdrop.hidden = true;
    modal.hidden = true;
    document.documentElement.style.overflow = "";
    setCooldown();
  }

  modal.querySelectorAll("[data-smu-upsell-close]").forEach((btn) => {
    btn.addEventListener("click", closeModal);
  });
  backdrop.addEventListener("click", closeModal);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !modal.hidden) closeModal();
  });

  async function getCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" }, cache: "no-store" });
    if (!res.ok) return null;
    return await res.json();
  }

  function countMagnets(cart) {
    if (!cart?.items?.length) return 0;
    return cart.items
      .filter((it) => MAGNET_PRODUCT_IDS.includes(Number(it.product_id)))
      .reduce((sum, it) => sum + (it.quantity || 0), 0);
  }

  function looksLikeCartAdd(url) {
    if (!url) return false;
    return String(url).includes("/cart/add");
  }

  let lastFire = 0;

  async function handleSuccessfulAdd(url) {
    if (!looksLikeCartAdd(url)) return;

    // Debounce (Apps feuern manchmal mehrfach)
    const t = now();
    if (t - lastFire < 400) return;
    lastFire = t;

    const cart = await getCart();
    if (!cart) return;

    const magnetQty = countMagnets(cart);

    // Popup nur, wenn insgesamt genau 1 Magnet im Warenkorb ist
    if (magnetQty === 1) {
      setTimeout(openModal, 150);
    }
  }

  // Hook fetch
  const origFetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await origFetch.apply(this, args);
    try {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url;
      if (res?.ok) handleSuccessfulAdd(url);
    } catch {}
    return res;
  };

  // Hook XHR
  const OriginalXHR = window.XMLHttpRequest;
  function XHRProxy() {
    const xhr = new OriginalXHR();
    let _url = "";
    const open = xhr.open;

    xhr.open = function (method, url, ...rest) {
      _url = url;
      return open.call(this, method, url, ...rest);
    };

    xhr.addEventListener("load", () => {
      try {
        if (xhr.status >= 200 && xhr.status < 300) handleSuccessfulAdd(_url);
      } catch {}
    });

    return xhr;
  }
  window.XMLHttpRequest = XHRProxy;
})();
